module.exports = __webpack_public_path__ + "ptc_nakagawa_V2.75aa6496.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_V2.jpg
// module id = SO6T
// module chunks = 0